// src/Components/Modules/Inventory/BOMList.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import { Box, Typography, Paper, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import { FaPlus, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';

export default function BOMList() {
    const [boms, setBoms] = useState([]);
    const [items, setItems] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ bom_name: '', finished_item_id: '', produced_quantity: 1, raw_materials: [{ raw_item_id: '', required_quantity: 1 }] });

    const fetchData = async () => {
        const [bRes, iRes] = await Promise.all([AxiosAuthInstance.get('manufacturing/boms'), AxiosAuthInstance.get('item_list')]);
        setBoms(bRes.data.boms || []);
        setItems(iRes.data.item || iRes.data || []);
    };
    useEffect(() => { fetchData(); }, []);

    const addRawMaterial = () => setForm({...form, raw_materials: [...form.raw_materials, { raw_item_id: '', required_quantity: 1 }]});
    const removeRawMaterial = (idx) => setForm({...form, raw_materials: form.raw_materials.filter((_, i) => i !== idx)});
    const updateRawMaterial = (idx, field, val) => {
        const newMats = [...form.raw_materials];
        newMats[idx][field] = val;
        setForm({...form, raw_materials: newMats});
    };

    const handleSave = async () => {
        try {
            await AxiosAuthInstance.post('manufacturing/boms', form);
            Swal.fire({ icon: 'success', title: 'BOM Created!', timer: 1500, showConfirmButton: false });
            setDialogOpen(false);
            fetchData();
        } catch (err) { Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed' }); }
    };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Bill of Materials (BOM)" />
            <Paper sx={{ p: 3, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h5" fontWeight={700}>Manufacturing Recipes (BOM)</Typography>
                <Button variant="contained" startIcon={<FaPlus />} onClick={() => setDialogOpen(true)}>Create BOM</Button>
            </Paper>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead><TableRow sx={{ bgcolor: '#f8f9fa' }}><TableCell>BOM Name</TableCell><TableCell>Finished Item</TableCell><TableCell>Yield Qty</TableCell><TableCell>Raw Materials Count</TableCell></TableRow></TableHead>
                    <TableBody>
                        {boms.map(b => (
                            <TableRow key={b.id} hover>
                                <TableCell><strong>{b.bom_name}</strong></TableCell>
                                <TableCell>{b.finished_item?.name || 'Unknown'}</TableCell>
                                <TableCell>{b.produced_quantity}</TableCell>
                                <TableCell>{b.raw_materials?.length || 0} items</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Create New BOM</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField label="BOM Name (e.g., Chair Assembly)" value={form.bom_name} onChange={e => setForm({...form, bom_name: e.target.value})} fullWidth />
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <FormControl fullWidth size="small"><InputLabel>Finished Item</InputLabel>
                                <Select value={form.finished_item_id} label="Finished Item" onChange={e => setForm({...form, finished_item_id: e.target.value})}>
                                    {items.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                            <TextField label="Produced Quantity" type="number" size="small" value={form.produced_quantity} onChange={e => setForm({...form, produced_quantity: e.target.value})} sx={{width: 150}} />
                        </Box>
                        <Typography variant="subtitle2" fontWeight={600} sx={{mt: 1}}>Raw Materials Required</Typography>
                        {form.raw_materials.map((mat, idx) => (
                            <Box key={idx} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <FormControl size="small" sx={{flex: 3}}><InputLabel>Raw Item</InputLabel>
                                    <Select value={mat.raw_item_id} label="Raw Item" onChange={e => updateRawMaterial(idx, 'raw_item_id', e.target.value)}>
                                        {items.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                <TextField size="small" type="number" label="Qty Needed" value={mat.required_quantity} onChange={e => updateRawMaterial(idx, 'required_quantity', Number(e.target.value))} sx={{flex: 1}} />
                                <IconButton onClick={() => removeRawMaterial(idx)} disabled={form.raw_materials.length === 1}><FaTrash size={14} /></IconButton>
                            </Box>
                        ))}
                        <Button variant="outlined" size="small" startIcon={<FaPlus />} onClick={addRawMaterial} sx={{alignSelf: 'flex-start'}}>Add Raw Material</Button>
                    </Box>
                </DialogContent>
                <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleSave}>Save BOM</Button></DialogActions>
            </Dialog>
        </Box>
    );
}